import React from "react";
import {HtmlDisplay} from "../../../Components/Display";
import {GridCell, gridConstants, GridContainer} from "../../../Components/Grid";
import {OrderPrintBarcode} from "./OrderPrintBarcode";
import {isArrayNullOrEmpty} from "../../../Utilities/Types/arrayUtilities";

interface OrderDetailsViewProps {
    orderDetails: Record<string, any>;
}

export const OrderDetailsView = ({
                                     orderDetails
                                 }: OrderDetailsViewProps) => {

    return <>
        <GridContainer>
            <GridCell medium_columns={gridConstants.column.SIX}>
                <HtmlDisplay html={orderDetails.details}/>
            </GridCell>
            <GridCell medium_columns={gridConstants.column.SIX}>
                {
                    orderDetails.shippingLocationName &&
                    <HtmlDisplay html={`<b class="h3">Shipping: </b>` + orderDetails.shipping}/>
                }

                {
                    !isArrayNullOrEmpty(orderDetails.volumes) &&
                    <>
                        <HtmlDisplay html={`<b class="h3">Access Numbers: </b>`}/>
                        <OrderPrintBarcode barcodes={orderDetails.volumes} />
                    </>
                }
            </GridCell>
        </GridContainer>
    </>;
};
